import React from "react";
import mxpIcons from "./svg/mxp-icons.svg";
import terraIcons from "./svg/ter-icons.svg";
import suIcons from "./svg/su-icons.svg";
import "./Icon.scss";

interface SBProps {
  "data-sb-object-id": string
}

interface IconProps {
  type: string;
  size?: string; 
  className?: string; 
  color?: string;
  sbProps?: SBProps;
}

const Icon = ({ type, size, className, color, sbProps }: IconProps) => {
  // icons with a type prefix of "ico-" are from the SketchUp icon library and consequently come from a different .svg file
  const getHumanNameForAltTag = (type?: string) => {
    if (!type) {
      return "icon";
    }

    let altName;
    if(type && typeof type === "string"){
      if (type?.toLowerCase()?.startsWith("mxp")) {
        altName = `icon for ${type.replace(/-/g, " ").replace(/mxp icon/, "")}`;
      }
      if (type?.toLowerCase()?.startsWith("ter-icon--")) {
        altName = `icon for ${type.replace(/-/g, " ").replace(/ter icon  /, "")}`;
      }
    }

    return altName || type;
  };

  return (
    <svg      
      {...sbProps}
      aria-label={getHumanNameForAltTag(type) || 'icon'}
      viewBox="0 0 8 8"
      role="img"
      className={`ter-icon ter-icon--${type} ter-icon--${size} ${ className ? className : "" }`}
      style={{ fill: color || "#242D2F", width: size || "16px", height: size || "16px" }}
    >
      <use
        xlinkHref={
          type && type.substring && type.substring(0, 3) === "su-"
            ? `${suIcons}#${type}`
            : type && type.substring && type.substring(0, 4) === "mxp-"
            ? `${mxpIcons}#${type}`
            : `${terraIcons}#${type}`
        }
      />
    </svg>
  );
};

export default Icon;
